import React from 'react';

// Déclaré en haut, hors du composant
const STATE_COLORS = {
  "ThreadState.CREATED": "border-gray-700 text-gray-500 bg-gray-900/20",
  "ThreadState.GETTING_PARAMS": "border-purple-500 text-purple-400 bg-purple-500/10",
  "ThreadState.REQUEST_SEND": "border-blue-500 text-blue-400 bg-blue-500/10",
  "ThreadState.RESPONSE_RECEIVED": "border-cyan-400 text-cyan-300 bg-cyan-400/10",
  "ThreadState.SAVING_RESULTS": "border-yellow-500 text-yellow-400 bg-yellow-500/10",
  "ThreadState.FINISHED": "border-green-500 text-green-500 bg-green-500/5 opacity-60",
};

function ThreadMiner({ name, state, layout_id, arr_to_mine }) {
  const statusClass = STATE_COLORS[state] || "border-gray-800 text-gray-400";
  const shortState = state ? state.split('.')[1] : "UNKNOWN";

  return (
    <div className={`h-[140px] p-3 rounded-lg border transition-all duration-300 flex flex-col justify-between ${statusClass}`}>
      <div>
        <div className="flex justify-between items-center mb-1">
          <span className="text-[9px] font-mono opacity-50">#{layout_id}</span>
          <div className={`w-1.5 h-1.5 rounded-full ${state?.includes('FINISHED') ? 'bg-green-500' : 'bg-current shadow-[0_0_5px_currentColor]'}`} />
        </div>
        <h3 className="text-[11px] font-bold uppercase truncate tracking-tighter">
          {name?.replace('Thread-', 'T-')}
        </h3>
      </div>

      <div className="flex flex-wrap gap-1 my-2">
        {arr_to_mine?.map((code, i) => (
          <span key={i} className="text-[8px] font-mono bg-black/40 px-1 py-0.5 rounded border border-white/5 text-gray-400">
            {code.toString().slice(-4)}
          </span>
        ))}
      </div>

      <div className="pt-2 border-t border-white/5 flex items-center justify-between">
        <span className="text-[9px] font-black uppercase tracking-widest">{shortState}</span>
      </div>
    </div>
  );
}

export default ThreadMiner;